import {
  SUBSCRIBE_TO_TOPIC,
  SubscribeToTopicAPI,
} from '@weblite-wapps/protocol'
import { wappSubscription } from '../helper/subscription-handler'
import { subscribeWappSessionToTopic } from '$logic/wapp-subscribed-topics'

wappSubscription.subscribe<SubscribeToTopicAPI>(
  SUBSCRIBE_TO_TOPIC,
  async ({ topic }, meta) => {
    await subscribeWappSessionToTopic(topic, meta.wappSessionId)
    return { status: 'ok' }
  },
)
